import React, { Component, Fragment } from 'react';
import { isEmpty } from "lodash"
import Spin from '../../../commonModules/interface/Spin';
import { BreadCrumb } from './containers/Layout';
import { Button, Grid, Box, IconButton } from '@material-ui/core';
import { ListRounded, ListAltRounded } from '@material-ui/icons';
import InputText, { InputSelect } from '../../../commonModules/interface/form-input-inline';
import CardPage from '../../../commonModules/layouts/CardPage';
import FormCredit from './credits/FormCredit';
import ListCredit from './credits/ListCredit.jsx';
import SingleShop from './shops/SingleShop';
import SingleSaleCredits from './credits/SingleSaleCredits';
import ListSale from './transfers/sales/ListTransferSale';
import AccordionFilter from './Filter/AccordionFilter';
import SingleTransferSale from './transfers/sales/SingleTransferSale';

class Credits extends Component{
    state = {
        view: this.props.new ? "new" : "list",
        listview: "credit",

        singleShop:{},
        singleCredit:{
            credit:{},
            shop:{},
            client:{},
            sale:{},
        },

        breadcrumb: "",
        currentPage: 0,
        currentPageSale: 0,
        rowsPerPage: 20,

        selectShop: "",
        searchType: "",
        searchClient: "",
        searchFacture: "",
        searchCredit: "", 
        searchSaleuct: "", 
    }
        
    componentDidMount = () => {
        if ( isEmpty(this.props.SALE_CREDITS) ){
            this.props.fetchSaleCredits()
        }
    }
    // select options 
        createShopList = () => {
            const list = [{value:"", label:"Tous les Magasins"}]
            const { SHOPS } = this.props
            if( !isEmpty(SHOPS) ){
                Object.values(SHOPS).forEach( shop => { 
                    list.push (       
                        {value:shop.id, label:shop.name} 
                    )
                })
            } 
            return list
        }
        createClientList = () => {
            const list = [{value:"", label:"Tous les Clients"}]
            const { CLIENTS } = this.props
            if( CLIENTS ){
                Object.values(CLIENTS).map(client => { 
                    list.push (       
                        {value:client.id, label:client.client_lastname} 
                    )
                })
            } 
            return list
        }
        handleChange = (e) => {
            const { name, value } = e.target;
            this.setState({
                [name]: value,
                currentPage: 0,
                currentPageSale: 0,
            })
        }
        handleSelect = (option, name) => {
            this.setState({
                [name]: option.value, 
                currentPage: 0,
                currentPageSale: 0,
            })
        } 

        getFilteredList = () => {
            const { SALE_CREDITS } = this.props;
            const { selectShop, searchClient, searchFacture, searchType } = this.state;
            
            let list = Object.values(SALE_CREDITS)
            
            // client
            if (!isEmpty(searchClient)) { 
                list = list.filter(item => item.client_ref === searchClient)
            }
            // type
            if(!isEmpty(searchType)){ 
                list = list.filter(item => item.nature === searchType)
            }
            // shop
            if(!isEmpty(selectShop)){  
                list = list.filter(item => item.shop_id === selectShop)
            }
            // fact
            if(!isEmpty(searchFacture)){
                list = list.filter(item => item.id && item.id.indexOf(searchFacture.toLocaleLowerCase()) > -1)
            }
            return list
        }

        getFilteredListSale = () => {
            const { SALES } = this.props;
            const { selectShop, searchClient, searchFacture, searchType } = this.state;
            
            let list = Object.values(SALES).filter(sale => sale.sale_credit)
           
            // client
            if (!isEmpty(searchClient)) {
                list = list.filter(item => item.client_ref === searchClient || item.sale_paygo_id === searchClient )
            }
            // type
            if(!isEmpty(searchType)){
                list = list.filter(item => item.nature === searchType)
            }
            // shop
            if(!isEmpty(selectShop)){
                list = list.filter(item => item.shop_id === selectShop)
            }
            // fact
            if(!isEmpty(searchFacture)){
                list = list.filter(item => item.id && item.id.indexOf(searchFacture.toLocaleLowerCase()) > -1)
            }
            return list
        }
        
    // CLEAR & DISPLAY
        handleClose = () => {
            this.setState({
                view:"list",
                breadcrumb: "",
            });
            // this.clearForms()
        }
        handleSingleCredit = (credit, shop, client, sale) => {
            this.setState({
                view:"credit",
                // breadcrumb:`${credit.nature} n°${credit.id}`,
                singleCredit:{credit, shop, client, sale},
            })
        }
        handleSingleShop = (shop) => {
            this.setState({
                breadcrumb: shop.name,
                singleShop:shop,
                view: "shop"
            })
        }
        handleSingleSale = (sale, shop, client) => {
            this.setState({
                view:"sale",
                breadcrumb:`${sale.nature} n°${sale.id}`,
                singleSale:{sale, shop, client},
            })
        }
        onChangePage = (pageOfItems, page, rowsPerPage) => {
            this.setState({ currentPage:page, rowsPerPage });
        }
        onChangePageSale = (pageOfItemsSale, page , rowsPerPage) => {
            this.setState({ currentPageSale:page , rowsPerPage});
        }
    render(){
        console.log("[STATE] stock ",this.state);
        let shops = this.createShopList()
        let clients = this.createClientList()

        return(
            <CardPage title="Ventes à crédit" storehouse action={
                <Box>
                    {this.state.view === "list" &&
                    <Fragment>
                        {/* <Button color="primary" variant="contained"
                            onClick={ ()=> this.setState({view: "new", breadcrumb:"Nouveau"}) }
                        >
                            Nouveau Paiement
                        </Button> */}
                        {this.state.listview === "credit" &&
                            <IconButton 
                                color="secondary"
                                title="Vue Ventes"
                                onClick={()=> this.setState({ view: "list", listview: "payList" }) }
                            >
                                <ListRounded />
                            </IconButton>
                        }
                        {this.state.listview === "payList" &&
                            <IconButton 
                            color="secondary"
                            title="Vue Paiement"
                            onClick={()=> this.setState({ view: "list", listview: "credit" }) }
                            >
                                <ListAltRounded />
                            </IconButton>
                        }
                    </Fragment>
                    }
                </Box>
            }>
                <BreadCrumb breadcrumb={ this.state.breadcrumb } title="Ventes" back={this.handleClose} />
                {this.props.STATE.credits.fetching && <Spin />}
               
                {this.state.view === "new" &&
                    <FormCredit {...this.props} close={ this.handleClose } />
                }
                {this.state.view === "credit" &&
                    <SingleSaleCredits 
                        title="Liste des paiement"
                        credit={this.state.singleCredit.credit} 
                        client={this.state.singleCredit.client} 
                        sale={this.state.singleCredit.sale}
                        {...this.props} 
                        closePopUp={() => this.setState({ view: "list", singleCredit:{
                            credit:{},
                            shop:{},
                            client:{},
                            sale:{},
                        },  }) }
                    />
                }
                {this.state.view === "sale" &&
                    <SingleTransferSale 
                        transfer={this.state.singleSale.sale} 
                        shop={this.state.singleSale.shop} 
                        client={this.state.singleSale.client} 
                        {...this.props} 
                        // getPhoto={this.props.getPhoto} 
                    />
                }
                {this.state.view === "shop" &&
                    <SingleShop shop={this.state.singleShop} {...this.props} />
                }
                  
                {this.state.view === "list" &&
                // {this.state.view === "list" && (this.state.listview === "credit" ||  this.state.listview === "payList") &&
                <AccordionFilter>
                    <Grid container>
                        <Grid item xs={12} md={6}>
                            <InputSelect
                                options={shops}
                                value={this.state.selectShop}
                                label="Sélectionner un Magasin"
                                onChange={(option) => this.handleSelect(option, "selectShop") }
                            /> 
                        </Grid>
                        
                        <Grid item xs={12} md={6}>
                            <InputSelect
                                options={[
                                    {value: "", label: "Tous"},
                                    {value: "payg", label: "PayG"},
                                    {value: "vente", label: "Vente"},
                                    {value: "commercial", label: "Commercial"},
                                ]}
                                value={this.state.searchType}
                                label="Type"
                                onChange={(option) => this.handleSelect(option, "searchType") }
                            /> 
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <InputSelect
                                options={clients}
                                value={this.state.searchClient}
                                label="Client"
                                onChange={(option) => this.handleSelect(option, "searchClient") }
                            /> 
                        </Grid>
                        
                        <Grid item xs={12} md={6}>
                            <InputText
                                label="Facture"
                                value={this.state.searchFacture}
                                name="searchFacture"
                                onChange={this.handleChange}
                            /> 
                        </Grid>
                    </Grid>
                </AccordionFilter>
                }
                {this.state.view === "list" && this.state.listview === "payList" &&
                <Box>                    
                    {!isEmpty(this.props.SALE_CREDITS) &&
                        <ListCredit 
                            {...this.props}
                            {...this.state}
                            onChangePage={this.onChangePage}
                            handleSingleShop={this.handleSingleShop}  
                            handleSingleCredit={this.handleSingleCredit}  
                            getFilteredList={this.getFilteredList}  
                        />
                    }
                </Box>
                }
                {this.state.view === "list" && this.state.listview === "credit" &&
                <Box> 
                    {/* {!isEmpty(this.props.SALE_CREDITS) && */}
                        <ListSale 
                            {...this.props}
                            {...this.state}
                            onChangePage={this.onChangePageSale}
                            handleSingleShop={this.handleSingleShop}  
                            handleSingleSale={this.handleSingleSale}  
                            getFilteredList={this.getFilteredListSale}  
                        />
                    {/* } */}
                </Box>
                }
            </CardPage>
        )
    }
}

export default Credits